// import h5Public from './public.js'

function getPower(type) {
	return !type ? 'admin' : type;
}

function setPower(type){
	return getPower(type);
}

export default {
	getPower,
	setPower,
}



// WEBPACK FOOTER //
// ./src/app/script/power.js